import styled from "styled-components";
import { colors, fontFamily } from "../../styles/Variables";
export const Body = styled.div`
    width: 100%;
    background-color: ${({ bgColor }) => bgColor || "var(--c-chrome-footer-bg)"};
    color: var(--c-chrome-footer-text);
    padding-top: 25px;
    font-size: 12px;
    font-family: ${fontFamily.secondary};
    
    a{
        color: var(--c-chrome-footer-text);
        text-decoration: none;
        font-size: 12px;
    }

    img {
        width: 128px;
        height: 28px;
    }
`
export const LinksWrapper = styled.div`
    @media (max-width: 768px) {
        display: none;
    }
`;

export const FooterText = styled.p`
    font-size: 11px;
    max-width: 800px;
    line-height: 1.5;
    text-align: justify;
    margin-bottom: 10px;

    @media (max-width: 768px) {
        padding: 0 0.5rem;
        max-width: 100%;
        text-align: left;
    }
`;
